<script>
import Modal from '@maison/components/common/Modal.vue';
import modalMixin from '@phoenix/mixins/modalMixin';

export default {
  components: {
    Modal,
  },

  mixins: [modalMixin],
};
</script>

<template>
  <modal :id="id" :title="$t('Product.weBoutiqueModalTitle')" small>
    <template #content>
      <slot />
    </template>
  </modal>
</template>
